/* global axios */
import ApiClient from './ApiClient';

class CustomEmailDomainAPI extends ApiClient {
  constructor() {
    super('escaleshop/email_sending_domain', {
      accountScoped: true,
      apiVersion: 'v1',
    });
  }

  get() {
    return axios.get(this.url);
  }

  register(domain) {
    return axios.post(this.url, { domain });
  }

  verify() {
    return axios.post(`${this.url}/verify`);
  }

  remove() {
    return axios.delete(this.url);
  }
}

export default new CustomEmailDomainAPI();
